<script>
import { mapState } from 'vuex'
import LoginScreenForm from '@/views/LoginScreenForm'
import VContentCard from '@/components/VContentCard'
import VAdvertiseImage from '@/components/VAdvertiseImage'
import auth from '@/auth'

export default {
  name: 'LoginScreen',

  components: {
    VContentCard,
    VAdvertiseImage,
    LoginScreenForm,
  },

  computed: {
    ...mapState({
      advertise: 'advertise'
    })
  },

  beforeMount() {
    this.$store.dispatch('SEARCH_ADVERTISE'),
    this.$store.dispatch('SEARCH_CLIENT_CONFIG')
      .catch(error => this.$log.error(error))
  },

  mounted() {
    let authorizationCode = auth.findAuthorizationCode(location.href);

    if (authorizationCode != null){
      const nextURL = location.href.replace("?code=".concat(authorizationCode), "");
      const nextTitle = 'Involves Stage';
      const nextState = { additionalInformation: 'Updated the URL with JS' };

      window.history.pushState(nextState, nextTitle, nextURL);
      window.history.replaceState(nextState, nextTitle, nextURL);

      this.$router.push({ name: 'authLoading', params: { code: authorizationCode }});
    }
    
    this.$ma.trackEvent({
      category: 'loginPage',
      properties: {
        releaseVersion: this.$store.state.version.system,
      },
    })
  },
}
</script>

<template>
  <VContentCard>
    <template slot="advertise">
      <VAdvertiseImage
        :visible="advertise.visible"
        :image="advertise.image"
        :link="advertise.link"
      />
    </template>

    <template slot="form">
      <LoginScreenForm />
    </template>
  </VContentCard>
</template>
